module.exports = __webpack_public_path__ + "assets/images/magenta_sport_1.e7089a323e93b896cb193c2d5de69c86.png";